var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('v-avatar',{staticStyle:{"border-radius":"10px"},attrs:{"size":_vm.size,"color":_vm.color}},[_c('span',{staticClass:"avatar__name"},[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }